import { FetchData } from "services/api";

export const fetchOrderClientsBranchCa = (body) =>
  FetchData("/api/order/clients/branchs/ca", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const fetchOrderSubcontractorsCaCosts = (body) =>
  FetchData("/api/order/subcontractors/ca/costs", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const fetchOrderLogs = (orderId, isPrestation, signal) =>
  FetchData(
    isPrestation
      ? `/api/order/log/order/prestation/${orderId}`
      : `/api/order/log/order/${orderId}`,
    {
      method: "GET",
      signal,
    },
  );

export const fetchOrdersDefault = () =>
  FetchData("/api/order", {
    method: "GET",
  });

export const fetchOrdersBetweenDate = (body, signal) =>
  FetchData("/api/order/between-date", {
    method: "POST",
    body: JSON.stringify(body),
    signal,
  });

/** Tous les order_id/order_st_id correspondant au filtre, sans pagination (action "sélectionner tout le filtre"). */
export const fetchOrderIdsBetweenDate = (body, signal) =>
  FetchData("/api/order/ids-between-date", {
    method: "POST",
    body: JSON.stringify(body),
    signal,
  });

export const fetchOrderClientsBranches = (clients) =>
  FetchData("/api/order/clients/branches", {
    method: "POST",
    body: JSON.stringify({ clients }),
  });

export const fetchOrderById = (orderId) =>
  FetchData(`/api/order/${orderId}`, {
    method: "GET",
  });

export const fetchInvoiceAvailable = (orderIds, currentType = "client") => {
  let payload;
  if (currentType === "client") {
    payload = { order_id: orderIds };
  } else {
    payload = { order_st_id: orderIds };
  }

  return FetchData("/api/order/invoice/available", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const sendOrderInvoices = (orderIds, type, currentType = "client") => {
  let payload;
  if (currentType === "client") {
    payload = {
      order_id: orderIds,
      type,
    };
  } else {
    payload = {
      order_st_id: orderIds,
      type,
    };
  }

  return FetchData("/api/order/invoice/send", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

/** Change le statut de plusieurs commandes en une fois (action groupée liste Commandes). */
export const bulkUpdateOrderStatus = (orderIds, order_statut_id, currentType = "client") => {
  const payload =
    currentType === "client"
      ? { order_id: orderIds, order_statut_id }
      : { order_st_id: orderIds, order_statut_id };

  return FetchData("/api/order/status/bulk", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

/** Synchronise une facture Dolibarr **brouillon** avec les commandes liées (lignes / modèle PDF). */
export const syncDraftOrderInvoices = (orderIds, currentType = "client") => {
  const payload =
    currentType === "client"
      ? { order_id: orderIds }
      : { order_st_id: orderIds };

  return FetchData("/api/order/invoice/sync-draft", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const createOrder = (payload) =>
  FetchData("/api/order", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const createPrestationOrder = (payload) =>
  FetchData("/api/order/prestation", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateOrder = (orderId, payload) =>
  FetchData(`/api/order/${orderId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const updatePrestationOrder = (orderId, payload) =>
  FetchData(`/api/order/prestation/${orderId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const uploadOrderEmailFile = (orderId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return FetchData(
    `/api/order/upload/email/${orderId}`,
    {
      method: "PUT",
      body: formData,
    },
    true,
  );
};

export const uploadOrderDocFile = (orderId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return FetchData(
    `/api/order/upload/doc/${orderId}`,
    {
      method: "PUT",
      body: formData,
    },
    true,
  );
};
